import { STriggerModal } from 'shj-components'
import { Form, Input, InputNumber, message, Select, Switch } from 'antd'
import { useEffect, useState } from 'react'
import { editDealkingVenueQrCode } from '@/services/talkOrder.ts'

const { Option } = Select
const { TextArea } = Input

const AddOrEditDom = (props: any) => {
  const { record, reload, onClose, categoryList, companyListData } = props
  const [submitLoading, setSubmitLoading] = useState(false)
  const [form] = Form.useForm()

  useEffect(() => {
    if (record?.id) {
      const companyCodeArr: string[] = []
      record?.useCompanyList?.forEach((item: any) => {
        companyCodeArr?.push(item?.busId)
      })
      form?.setFieldsValue({ ...record, useCompanyList: companyCodeArr })
    }
  }, [])

  const onFinish = () => {
    form.validateFields().then((values: any) => {
      const newValues = { ...values }
      const target = companyListData?.filter((item: any) => item?.code === values?.companyCode)
      newValues.companyName = target?.[0]?.name
      const target2 = categoryList?.filter((item: any) => item?.priKey === values?.areaType)
      newValues.areaTypeDesc = target2?.[0]?.name
      const target3 = companyListData?.filter((item: any) =>
        values?.useCompanyList.includes(item?.id)
      )
      const useCompanyList: any = []
      target3?.forEach((item: any) => {
        useCompanyList?.push({
          busName: item?.name,
          busCode: item?.code,
          busId: item?.id,
        })
      })
      newValues.useCompanyList = useCompanyList
      setSubmitLoading(true)
      if (record?.id) newValues.id = record?.id
      editDealkingVenueQrCode(newValues)
        .then((res: any) => {
          message.success('操作成功')
          onClose?.()
          reload?.()
        })
        .finally(() => setSubmitLoading(false))
    })
  }

  return (
    <STriggerModal
      title={record?.id ? '编辑' : '新增'}
      open={true}
      cancelText="取消"
      okText="保存"
      onOk={onFinish}
      onCancel={onClose}
      confirmLoading={submitLoading}
    >
      <Form form={form} layout="vertical" autoComplete="off">
        <Form.Item
          label="区域分类"
          name="areaType"
          rules={[{ required: true, message: '不能为空' }]}
        >
          <Select
            placeholder="请选择区域分类"
            allowClear
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              option?.children?.toLowerCase().indexOf(input?.toLowerCase()) >= 0
            }
          >
            {categoryList?.map((item: any) => {
              return (
                <Option key={item.priKey} value={item.priKey}>
                  {item.name}
                </Option>
              )
            })}
          </Select>
        </Form.Item>
        <Form.Item label="区域别名" name="alias">
          <Input placeholder="请输入区域别名" maxLength={10} />
        </Form.Item>
        <Form.Item
          label="门店"
          name="useCompanyList"
          rules={[{ required: true, message: '不能为空' }]}
        >
          <Select
            placeholder="请选择门店"
            allowClear
            showSearch
            mode="multiple"
            optionFilterProp="children"
            filterOption={(input, option) =>
              option?.children?.toLowerCase().indexOf(input?.toLowerCase()) >= 0
            }
          >
            {companyListData?.map((item: any) => {
              return (
                <Option key={item.id} value={item.id}>
                  {item.name}
                </Option>
              )
            })}
          </Select>
        </Form.Item>
        <Form.Item label="排序" name="sortNumber" rules={[{ required: true, message: '不能为空' }]}>
          <InputNumber placeholder="请输入排序" style={{ width: '100%' }} min={0} max={9999} />
        </Form.Item>
        <Form.Item label="讲解用时（分钟）" name="explanTime">
          <InputNumber style={{ width: '100%' }} placeholder="请输入讲解用时" />
        </Form.Item>
        <Form.Item label="当期是否有活动" valuePropName="checked" name="currentActivity">
          <Switch />
        </Form.Item>
        <Form.Item label="区域描述" name="name">
          <TextArea maxLength={300} placeholder="请输入区域描述" rows={3} />
        </Form.Item>
      </Form>
    </STriggerModal>
  )
}

export default AddOrEditDom
